import { IApplicationState, TCardId } from 'app/types/types';
import { IDescriptionUnsavedState } from '../types';

export const getDescriptionUnsaved = (
    state: IApplicationState,
    cardId: TCardId
): IDescriptionUnsavedState => {
    return state.cardPanel.cardDescriptionUnsaved[cardId];
};
